import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnumTranslationPipe } from "./enum-translation.pipe";
import {NumberFormatPipe} from "./number.pipe";

@NgModule({
  declarations: [
    EnumTranslationPipe,
    NumberFormatPipe
  ],
  exports: [
    EnumTranslationPipe,
    NumberFormatPipe
  ],
  imports: [
    CommonModule
  ]
})
export class PipesModule { }
